'use client';
import { Box, Text } from '@chakra-ui/react';
import Image from 'next/image';
import { useMemo, useEffect, useRef } from 'react';
import { SwiffyNewsSliderProps } from 'types/common';
import { SwiffyNewsSliderStyles } from 'styles/homeStyles';
import { useRouter } from 'next/navigation';
declare global {
  interface Window {
    swiffyslider?: {
      init: (element?: HTMLElement) => void;
      initSlider: (element: HTMLElement) => void;
    };
  }
}

export const SwiffyNewsSlider = ({ noticias = [] }: SwiffyNewsSliderProps) => {
  const sliderRef = useRef<HTMLDivElement>(null);
  const memoizedNoticias = useMemo(() => noticias, [noticias]);
  const router = useRouter();

  useEffect(() => {
    const initializeSlider = () => {
      if (sliderRef.current && window.swiffyslider) {
        try {
          setTimeout(() => {
            if (sliderRef.current && window.swiffyslider) {
              window.swiffyslider.init();
            }
          }, 50);
        } catch (error) {
          console.warn('Erro ao inicializar Swiffy Slider:', error);
        }
      }
    };

    if (window.swiffyslider) {
      initializeSlider();
    } else {
      // Aguarda o script carregar com mais tentativas
      let attempts = 0;
      const maxAttempts = 50;
      
      const checkSwiffySlider = setInterval(() => {
        attempts++;
        if (window.swiffyslider) {
          clearInterval(checkSwiffySlider);
          initializeSlider();
        } else if (attempts >= maxAttempts) {
          clearInterval(checkSwiffySlider);
          console.warn('Swiffy Slider não carregou após', maxAttempts, 'tentativas');
        }
      }, 100);

      return () => {
        clearInterval(checkSwiffySlider);
      };
    }
  }, []);


  return (
    <>
      <Box
        id="swiffy-animation"
        ref={sliderRef}
        data-slider-nav-autoplay-interval="4000"
        className="
        swiffy-slider 
        slider-nav-autoplay
        slider-item-ratio 
        slider-item-ratio-16x9 
        slider-nav-visible 
        slider-nav-round
        slider-nav-animation
        slider-nav-animation-scale
        "
        // slider-nav-animation-fadein

        style={{
          '--swiffy-slider-nav-light': '#8C1614',
          '--swiffy-slider-nav-dark': '#ffffff', 
          } as any}
          boxShadow="sm"
        >
        <ul className="slider-container">
          {memoizedNoticias.map((noticia) => (
          <li
            key={noticia._id}
            className="slide-visible"
            onClick={() => router.push(`/noticias/${noticia.slug}`)}
            style={{
              transition:"transform 0.2s ease-in-out",
              cursor:"pointer"
            }}
            onMouseEnter={(e) => {
              (e.currentTarget as HTMLElement).style.transform = "scale(1.02)";
            }}
            onMouseLeave={(e) => {
              (e.currentTarget as HTMLElement).style.transform = "scale(1)";
            }}
          >      
     
              <Box {...SwiffyNewsSliderStyles.imageBox}>
                <Image
                  src={noticia.thumbImage.url}
                  alt={noticia.title}
                  priority
                  loading="eager"
                  fill
                  sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 33vw"
                  style={{ objectFit: 'cover' }}
                  quality={95}
                  placeholder="blur"
                  blurDataURL="data:image/jpeg;base64,/9j/..."
                />
              </Box>
              <Box {...SwiffyNewsSliderStyles.textBox}>
                <Text {...SwiffyNewsSliderStyles.titleText}>{noticia.title}</Text>
                <Text {...SwiffyNewsSliderStyles.descriptionText}>{noticia.descriptionSmall}</Text>
              </Box>
            </li>
          ))}
        </ul>

        <button 
          type="button" 
          className="slider-nav" 
          aria-label="Slide anterior" 
          data-slider-nav="prev"
        />
        <button 
          type="button" 
          className="slider-nav slider-nav-next" 
          aria-label="Próximo slide" 
          data-slider-nav="next"
        />

        <div className="slider-indicators">
          {memoizedNoticias.map((_, i) => (
            <button 
              key={i} 
              aria-label={`Ir para slide ${i + 1}`}
            />
          ))}
        </div>
      </Box>
    </>
  );
};